import RouterLink from 'next/link';
import { forwardRef } from 'react';
import { classes } from 'utils/style';
import { isExternalLink, getExternalLinkProps } from 'utils/url';
import styles from './Link.module.css';

// File extensions that can be linked to
const VALID_EXT = ['txt', 'png', 'jpg'];

function isAnchor(href) {
  const isValidExtension = VALID_EXT.includes(href?.split('.').pop());
  return isExternalLink(href) || href?.[0] === '#' || isValidExtension;
}

export const Link = forwardRef(
  ({ href, rel, target, children, secondary, className, ...rest }, ref) => {
    const { rel: relValue, target: targetValue } = getExternalLinkProps(href, rel, target);

    const linkProps = {
      className: classes(styles.link, className),
      'data-secondary': secondary,
      rel: relValue,
      target: targetValue,
      ref,
      ...rest,
    };

    if (isAnchor(href)) {
      return (
        <a href={href} {...linkProps}>
          {children}
        </a>
      );
    }

    return (
      <RouterLink href={href} scroll={false} {...linkProps}>
        {children}
      </RouterLink>
    );
  }
);

// Keep LinkContent for backwards compatibility
export const LinkContent = Link;
